/**
 * Do not edit directly
 * Generated on Mon, 22 May 2023 22:40:41 GMT
 */

export const DlColorBrandPrimaryDarkest = "#400000";
export const DlColorBrandPrimaryDark = "#9f0f00";
export const DlColorBrandPrimaryMedium = "#ec3a0e";
export const DlColorBrandPrimaryLight = "#ff8679";
export const DlColorBrandPrimaryLightest = "#fff2f2";
export const DlColorBrandHighlightDarkest = "#001840";
export const DlColorBrandHighlightDark = "#003d9f";
export const DlColorBrandHighlightMedium = "#0064d1";
export const DlColorBrandHighlightLight = "#79acff";
export const DlColorBrandHighlightLightest = "#f2f7ff";
export const DlColorNeutralDarkest = "#202020";
export const DlColorNeutralDark = "#6c6c6c";
export const DlColorNeutralMedium = "#dedede";
export const DlColorNeutralLight = "#f7f7f7";
export const DlColorNeutralLightest = "#fcfcfc";
export const DlColorSupportPositiveDarkest = "#003421";
export const DlColorSupportPositiveDark = "#006e4a";
export const DlColorSupportPositiveMedium = "#0e9069";
export const DlColorSupportPositiveLight = "#79d6b7";
export const DlColorSupportPositiveLightest = "#f2fdf9";
export const DlColorSupportWarningDarkest = "#402200";
export const DlColorSupportWarningDark = "#9f5200";
export const DlColorSupportWarningMedium = "#d97d08";
export const DlColorSupportWarningLight = "#ffbe79";
export const DlColorSupportWarningLightest = "#fff9f2";
export const DlColorSupportNegativeDarkest = "#400016";
export const DlColorSupportNegativeDark = "#9f003c";
export const DlColorSupportNegativeMedium = "#e20867";
export const DlColorSupportNegativeLight = "#ff79ac";
export const DlColorSupportNegativeLightest = "#fff2f7";
export const DlBorderRadiusSharp = 0;
export const DlBorderRadiusSm = "4px";
export const DlBorderRadiusMd = "8px";
export const DlBorderRadiusLg = "16px";
export const DlBorderRadiusPill = "500px";
export const DlBorderRadiusCircular = "1000px";
export const DlBorderRadiusSharpRem = 0;
export const DlBorderRadiusSmRem = "0.25rem";
export const DlBorderRadiusMdRem = "0.5rem";
export const DlBorderRadiusLgRem = "1rem";
export const DlBorderRadiusPillRem = "31.25rem";
export const DlBorderRadiusCircularRem = "62.5rem";
export const DlBorderWidthNone = 0;
export const DlBorderWidthHairline = "1px";
export const DlBorderWidthThick = "2px";
export const DlBorderWidthHeavy = "4px";
export const DlBorderWidthNoneRem = 0;
export const DlBorderWidthHairlineRem = "0.0625rem";
export const DlBorderWidthThickRem = "0.125rem";
export const DlBorderWidthHeavyRem = "0.25rem";
export const DlGridBreakpointMobile = "576px";
export const DlGridBreakpointDesktop = "1200px";
export const DlGridBreakpointMobileRem = "36rem";
export const DlGridBreakpointDesktopRem = "75rem";
export const DlOpacitySemiOpaque = 0.72;
export const DlOpacityIntense = 0.32;
export const DlOpacityLight = 0.16;
export const DlOpacitySemiTransparent = 0.08;
export const DlShadowUp01 = "0px 0px 4px rgba(136, 128, 128, 0.08), 0px -8px 16px -4px rgba(136, 128, 128, 0.16)";
export const DlShadowUp02 = "0px 0px 8px rgba(136, 128, 128, 0.08), 0px -16px 32px -8px rgba(136, 128, 128, 0.16)";
export const DlShadowUp03 = "0px 0px 16px rgba(136, 128, 128, 0.08), 0px -32px 64px -16px rgba(136, 128, 128, 0.16)";
export const DlShadowDown01 = "0px 0px 4px rgba(136, 128, 128, 0.08), 0px 8px 16px -4px rgba(136, 128, 128, 0.16)";
export const DlShadowDown02 = "0px 0px 8px rgba(136, 128, 128, 0.08), 0px 16px 32px -8px rgba(136, 128, 128, 0.16)";
export const DlShadowDown03 = "0px 0px 16px rgba(136, 128, 128, 0.08), 0px 32px 64px -16px rgba(136, 128, 128, 0.16)";
export const DlSpacingInlineQuarck = "4px";
export const DlSpacingInlineNano = "8px";
export const DlSpacingInlineMicro = "12px";
export const DlSpacingInlineXxxs = "16px";
export const DlSpacingInlineXxs = "24px";
export const DlSpacingInlineXs = "32px";
export const DlSpacingInlineSm = "40px";
export const DlSpacingInlineMd = "48px";
export const DlSpacingInlineLg = "56px";
export const DlSpacingInlineXl = "80px";
export const DlSpacingInlineQuarckRem = "0.25rem";
export const DlSpacingInlineNanoRem = "0.5rem";
export const DlSpacingInlineMicroRem = "0.75rem";
export const DlSpacingInlineXxxsRem = "1rem";
export const DlSpacingInlineXxsRem = "1.5rem";
export const DlSpacingInlineXsRem = "2rem";
export const DlSpacingInlineSmRem = "2.5rem";
export const DlSpacingInlineMdRem = "3rem";
export const DlSpacingInlineLgRem = "3.5rem";
export const DlSpacingInlineXlRem = "5rem";
export const DlSpacingInsetNano = "4px";
export const DlSpacingInsetXs = "8px";
export const DlSpacingInsetSm = "16px";
export const DlSpacingInsetMd = "24px";
export const DlSpacingInsetLg = "32px";
export const DlSpacingInsetXl = "48px";
export const DlSpacingInsetNanoRem = "0.25rem";
export const DlSpacingInsetXsRem = "0.5rem";
export const DlSpacingInsetSmRem = "1rem";
export const DlSpacingInsetMdRem = "1.5rem";
export const DlSpacingInsetLgRem = "2rem";
export const DlSpacingInsetXlRem = "3rem";
export const DlSpacingSquishNano = "4px 8px";
export const DlSpacingSquishXs = "8px 16px";
export const DlSpacingSquishSm = "16px 24px";
export const DlSpacingSquishMd = "16px 32px";
export const DlSpacingSquishNanoRem = "0.25rem 0.5rem";
export const DlSpacingSquishXsRem = "0.5rem 1rem";
export const DlSpacingSquishSmRem = "1rem 1.5rem";
export const DlSpacingSquishMdRem = "1rem 2rem";
export const DlSpacingStackQuarck = "4px";
export const DlSpacingStackNano = "8px";
export const DlSpacingStackMicro = "12px";
export const DlSpacingStackXxxs = "16px";
export const DlSpacingStackXxs = "24px";
export const DlSpacingStackXs = "32px";
export const DlSpacingStackSm = "40px";
export const DlSpacingStackMd = "48px";
export const DlSpacingStackLg = "56px";
export const DlSpacingStackXl = "72px";
export const DlSpacingStackXxl = "96px";
export const DlSpacingStackXxxl = "120px";
export const DlSpacingStackHuge = "160px";
export const DlSpacingStackQuarckRem = "0.25rem";
export const DlSpacingStackNanoRem = "0.5rem";
export const DlSpacingStackMicroRem = "0.75rem";
export const DlSpacingStackXxxsRem = "1rem";
export const DlSpacingStackXxsRem = "1.5rem";
export const DlSpacingStackXsRem = "2rem";
export const DlSpacingStackSmRem = "2.5rem";
export const DlSpacingStackMdRem = "3rem";
export const DlSpacingStackLgRem = "3.5rem";
export const DlSpacingStackXlRem = "4.5rem";
export const DlSpacingStackXxlRem = "6rem";
export const DlSpacingStackXxxlRem = "7.5rem";
export const DlSpacingStackHugeRem = "10rem";
export const DlFontFamilyLight = "'AlicorpSans-Light', Helvetica, Arial, sans-serif"; // 300
export const DlFontFamilyRegular = "'AlicorpSans-Regular', Helvetica, Arial, sans-serif"; // 400
export const DlFontFamilyBold = "'AlicorpSans-Bold', Helvetica, Arial, sans-serif"; // 700
export const DlFontFamilySemibold = "'AlicorpSans-Semibold', Helvetica, Arial, sans-serif"; // 600
export const DlFontFamilyMonospace = "SFMono-Regular, Menlo, Monaco, Consolas,  'Liberation Mono', 'Courier New', monospace";
export const DlFontSizeXxl = "80px";
export const DlFontSizeXl = "64px";
export const DlFontSizeLg = "48px";
export const DlFontSizeMd = "40px";
export const DlFontSizeSm = "32px";
export const DlFontSizeXs = "24px";
export const DlFontSizeXxs = "20px";
export const DlFontSizeXxxs = "16px";
export const DlFontSizeNano = "14px";
export const DlFontSizeQuarck = "12px";
export const DlFontSizeXxlRem = "5rem";
export const DlFontSizeXlRem = "4rem";
export const DlFontSizeLgRem = "3rem";
export const DlFontSizeMdRem = "2.5rem";
export const DlFontSizeSmRem = "2rem";
export const DlFontSizeXsRem = "1.5rem";
export const DlFontSizeXxsRem = "1.25rem";
export const DlFontSizeXxxsRem = "1rem";
export const DlFontSizeNanoRem = "0.875rem";
export const DlFontSizeQuarckRem = "0.75rem";
export const DlFontWeightLight = 300; // light
export const DlFontWeightRegular = 400; // regular
export const DlFontWeightSemibold = 600; // semibold
export const DlFontWeightBold = 700; // bold
export const DlLineHeightTight = "1";
export const DlLineHeightFair = "1.28";
export const DlLineHeightConfy = "1.52";
export const DlLineHeightHuge = "96px";
export const DlLineHeightXxxl = "80px";
export const DlLineHeightXxl = "56px";
export const DlLineHeightXl = "48px";
export const DlLineHeightLg = "40px";
export const DlLineHeightMd = "36px";
export const DlLineHeightSm = "28px";
export const DlLineHeightXs = "24px";
export const DlLineHeightXxs = "20px";
export const DlLineHeightXxxs = "18px";
export const DlLineHeightMicro = "16px";
export const DlLineHeightNano = "14px";
export const DlLineHeightQuarck = "12px";
export const DlLineHeightHugeRem = "6rem";
export const DlLineHeightXxxlRem = "5rem";
export const DlLineHeightXxlRem = "3.5rem";
export const DlLineHeightXlRem = "3rem";
export const DlLineHeightLgRem = "2.5rem";
export const DlLineHeightMdRem = "2.25rem";
export const DlLineHeightSmRem = "1.75rem";
export const DlLineHeightXsRem = "1.5rem";
export const DlLineHeightXxsRem = "1.25rem";
export const DlLineHeightXxxsRem = "1.125rem";
export const DlLineHeightMicroRem = "1rem";
export const DlLineHeightNanoRem = "0.875rem";
export const DlLineHeightQuarckRem = "0.75rem";